export const BECOME_PARTNER_FORM = [

	// Step 1 - Personal Details [START]
	{
		label: 'become.partner.step1.title',
		sections: [
			{
				label: 'become.partner.personal.heading',
				switch: {
					name: 'customerType',
					options: [
						{ key: 'become.partner.form.customertype.individual', value: 'PFX' },
						{ key: 'become.partner.form.customertype.company', value: 'CFX' }
					]
				},
				type: 'input',
				fields: [
					{
						name: 'salutation',
						key: 'become.partner.form.salutation',
						component: 'select',
						required: true,
						reference: 'salutation'
					},
					{
						name: 'firstName',
						key: 'become.partner.form.firstname',
						component: 'text',
						required: true,
						validation: /^\S.{0,39}$/
					},
					{
						name: 'lastName',
						key: 'become.partner.form.lastname',
						component: 'text',
						required: true,
						validation: /^\S.{0,39}$/
					},
					{
						name: 'mobile',
						key: 'become.partner.form.mobile',
						component: 'combo',
						required: true,
						validation: /^(\+)?([0-9]){10,16}$/i,
						reference: 'dialing'
					}
				]
			},
			{
				label: 'become.partner.company.heading',
				condition: {
					name: 'customerType',
					value: ['CFX']
				},
				type: 'input',
				fields: [
					{
						name: 'companyName',
						key: 'become.partner.form.company',
						component: 'text',
						required: true,
						validation: /^\S.{0,49}$/
					},
					{
						name: 'trading_name',
						key: 'become.partner.form.trading_name',
						component: 'text',
						required: false,
						validation: /^\S.{0,99}$/
					}
				]
			},
			{
				label: 'become.partner.address.heading',
				type: 'input',
				fields: [
					{
						name: 'address',
						key: 'become.partner.form.address',
						component: 'address',
						required: true,
						isRegistration: false
					},
					{
						name: 'addressUSAStateDisclaimer',
						component: 'label',
						required: false
					},
					{
						name: 'taxNumber',
						key: 'become.partner.form.tax_number',
						component: 'text',
						required: true,
						validation: /^([0-9]{9}|[a-zA-Z]{1}[0-9]{8}|[0-9]{8}[a-zA-Z]{1}|[a-zA-Z]{1}[0-9]{7}[a-zA-Z]{1})$/
					},
				]
			},
		]
	},

	// Step 2 - Login Details [START]
	{
		label: 'become.partner.step2.title',
		sections: [
			{
				label: 'become.partner.login.heading',
				type: 'input',
				fields: [
					{
						name: 'email',
						key: 'become.partner.form.email',
						component: 'text',
						disableautofill: 'new-email',
						required: true,
						validation: /^(([a-zA-Z0-9!#$%&'*+-\/=?^_`{|]{1,64})([@]{1})([a-zA-Z0-9-.]{2,160})([.]{1})([a-zA-Z0-9-.]{2,24}))$/i // eslint-disable-line
					},
					{
						name: 'password',
						key: 'become.partner.form.password',
						component: 'text',
						disableautofill: 'new-password',
						reference: 'password',
						passwordCriteria: true,
						required: true,
						supportsUnmasking: true,
						validation: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*"£^()+={}\|?><,._])(?=.*[0-9])(?=.{10,16}$)/,// eslint-disable-line
					}
				]
			}
		]
	},

	// Step 3 - Bank Details [START]
	{
		label: 'become.partner.step3.title',
		sections: [
			{
				prependedIcon: true,
				prependedTitle: 'become.partner.step3.prependedTitle',
				prependedCopy: 'become.partner.step3.prependedCopy',
				skipStep: true,
				label: 'become.partner.bank.heading',
				type: 'input',
				fields: [
					{
						name: 'account',
						key: 'become.partner.bank.details',
						component: 'bankdetails',
						required: true
					}
				]
			},
		]
	},

	// Step 4 - Your Clients [START]
	{
		label: 'become.partner.step4.title',
		sections: [
			{
				label: 'become.partner.clients.heading',
				type: 'input',
				fields: [
					{
						name: 'personalClients',
						key: 'become.partner.form.personalClients',
						component: 'checkbox',
						required: false,
						value: 'Personal clients'
					},
					{
						name: 'onlineMarketSellers',
						key: 'become.partner.form.onlineMarketSellers',
						component: 'checkbox',
						required: false
					},
					{
						name: 'corporateClients',
						key: 'become.partner.form.corporateClients',
						component: 'checkbox',
						required: false
					},
					{
						key: 'become.partner.form.businessSector',
						component: 'select',
						name: 'businessSector',
						reference: 'businessSector',
						required: true
					},
					{
						key: 'become.partner.form.businessCategory',
						component: 'select',
						name: 'businessCategory',
						reference: 'businessCategory',
						required: true
					},
					{
						key: 'become.partner.form.industries',
						component: 'multiselect',
						name: 'industry',
						reference: 'industry',
						required: true
					},
					{
						key: 'become.partner.form.countries',
						component: 'multiselect',
						name: 'country',
						reference: 'country',
						required: true
					},
					{
						key: 'become.partner.form.languages',
						component: 'multiselect',
						name: 'language',
						reference: 'language',
						required: true
					},
				]
			}
		]
	},

	// Step 5 - Confirmation [START]
	{
		label: 'become.partner.step5.title',
		sections: [
			{
				type: 'accordions',
				accordions: [
					// Accordion one
					{
						label: 'become.partner.step1.title',
						editLink: true,
						items: [
							{
								key: 'become.partner.summary.customertype',
								combine: ['customerType']
							},
							{
								key: 'become.partner.summary.companyName',
								combine: ['companyName']
							},
							{
								key: 'become.partner.summary.trading_name',
								combine: ['trading_name']
							},
							{
								key: 'become.partner.summary.fullname',
								combine: ['salutation', 'firstName', 'lastName']
							},
							{
								key: 'become.partner.summary.mobile',
								combine: ['mobile']
							},
							{
								key: 'become.partner.summary.address',
								combine: ['address.line1', 'address.city', 'address.county', 'address.postcode', 'address.country'],
								using: ', '
							},
							{
								key: 'become.partner.summary.tax_number',
								combine: ['taxNumber'],
							},
						],
					},
					// Accordion two
					{
						label: 'become.partner.step2.title',
						editLink: true,
						items: [
							{
								key: 'become.partner.summary.email',
								combine: ['email']
							},
							{
								key: 'become.partner.summary.password',
								combine: ['password']
							},
						],
					},
					// Accordion three
					{
						label: 'become.partner.step3.title',
						editLink: true,
						items: [
							{
								key: 'become.partner.summary.bank.name',
								combine: ['account.bank_account_name']
							},
							{
								key: 'become.partner.summary.bank.country',
								combine: ['account.payment_country']
							},
							{
								key: 'become.partner.summary.bank.currency',
								combine: ['account.payment_currency']
							},
							{
								key: 'become.partner.summary.bank.account_number',
								combine: ['account.account_number']
							},
							{
								key: 'become.partner.summary.bank.sort_code',
								combine: ['account.sort_code']
							},
							{
								key: 'become.partner.summary.bank.bsb_number',
								combine: ['account.bsb_number']
							},
							{
								key: 'become.partner.summary.bank.swift_code',
								combine: ['account.swift_code']
							},
							{
								key: 'become.partner.summary.bank.transit_number',
								combine: ['account.transit_number']
							},
							{
								key: 'become.partner.summary.bank.aba_number',
								combine: ['account.aba_number']
							},
							{
								key: 'become.partner.summary.bank.branch_code',
								combine: ['account.branch_code']
							},
							{
								key: 'become.partner.summary.bank.ifsc_code',
								combine: ['account.ifsc_code']
							},
							{
								key: 'become.partner.summary.bank.iban',
								combine: ['account.iban']
							},
							{
								key: 'become.partner.summary.bank.cnaps_code',
								combine: ['account.cnaps_code']
							},
							{
								key: 'become.partner.summary.bank.bank_name',
								combine: ['account.bank_name']
							},
							{
								key: 'become.partner.summary.bank.bank_address',
								combine: ['account.bank_address']
							}
						],
					},
					// Accordion four
					{
						label: 'become.partner.step4.title',
						editLink: true,
						items: [
							{
								key: 'become.partner.summary.services',
								combine: ['personalClients', 'onlineMarketSellers', 'corporateClients'],
								format: 'checkboxes',
								using: ', '
							},
							{
								key: 'become.partner.summary.businessSector',
								combine: ['businessSector']
							},
							{
								key: 'become.partner.summary.businessCategory',
								combine: ['businessCategory']
							},
							{
								key: 'become.partner.summary.industries',
								combine: ['industry']
							},
							{
								key: 'become.partner.summary.countries',
								combine: ['country']
							},
							{
								key: 'become.partner.summary.languages',
								combine: ['language']
							}
						],
					},
				]
			},
			{
				type: 'input',
				fields: [
					{
						name: 'terms',
						key: 'become.partner.summary.terms',
						component: 'checkbox',
						required: true,
					}
				]
			}
		]
	},

];
